import { Component } from "@angular/core";
import { Container } from "@components/container/container";
import { ErrorModal } from "@components/error-modal/error-modal";

@Component({
  selector: "app-error-page",
  standalone: true,
  imports: [Container, ErrorModal],
  template: `
    <app-container>
      <div class="error-page__wrapper">
        <app-error-modal />
      </div>
    </app-container>
  `,
  styles: `
    .error-page__wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      width: 100%;
      margin: auto;
    }
  `,
})
export class ErrorPage {}
